import {
    AppState,
    AuthenticationState,
    THEWEST_ALL,
} from '@news-mono/web-common'
import { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
    BreachContext,
    BreachScreenContext,
} from '../../../../web-common/src/context-providers/BreachContextProvider'
import {
    BreachWallContentType,
    SubscriptionPackageOptions,
} from './helpers/BreachWallTypes'
import { getRrmeOfferPackages } from '../../subscription-offers/SubscriptionOffers'
import {
    WEEKLY_DIGITAL_RATE_CODE,
    WEEKLY_DIGITAL_RATE_CODE_INCREASE,
    WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE,
    WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE_INCREASE,
    FIFTY_OFF_WE_PAPER_EVERYDAY_DIGITAL_8_WEEKS_RATE_CODE,
    FIFTY_OFF_EVERYDAY_DIGITAL_12_WEEKS_RATE_CODE,
    FIFTY_OFF_FRI_MON_PAPER_AND_DIGITAL_12_WEEKS_RATE_CODE,
    THIRTY_OFF_EVERYDAY_DIGITAL_8_WEEKS_RATE_CODE,
    FIFTY_OFF_EVERYDAY_DIGITAL_8_WEEKS_RATE_CODE,
    SPORT_BREACH_DIGITAL_PRINT_RATE_CODE,
    EVERYDAY_DIGITAL_52_WEEKS_RATE_CODE,
    BASE_50_DEAL_OFFERCODE,
    EVERYDAY_DIGITAL,
    EVERYDAY_DIGITAL_INCREASE,
    WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL,
    WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL_INCREASE,
    FRI_TO_MON_PAPERS_AND_EVERYDAY_DIGITAL,
    FIFTY_OFF_EVERYDAY_DIGITAL,
    FIFTY_OFF_WE_PAPERS_AND_EVERYDAY_DIGITAL,
    FIFTY_OFF_FRI_TO_MON_PAPERS_AND_EVERYDAY_DIGITAL,
    THIRTY_OFF_EVERYDAY_DIGITAL,
} from './constants'

export type SubscriptionPackages = SubscriptionPackageOptions[]

// Re-export constants for backward compatibility
export {
    WEEKLY_DIGITAL_RATE_CODE,
    WEEKLY_DIGITAL_RATE_CODE_INCREASE,
    WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE,
    WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE_INCREASE,
    FIFTY_OFF_WE_PAPER_EVERYDAY_DIGITAL_8_WEEKS_RATE_CODE,
    FIFTY_OFF_EVERYDAY_DIGITAL_12_WEEKS_RATE_CODE,
    FIFTY_OFF_FRI_MON_PAPER_AND_DIGITAL_12_WEEKS_RATE_CODE,
    EVERYDAY_DIGITAL_52_WEEKS_RATE_CODE,
    BASE_50_DEAL_OFFERCODE,
    EVERYDAY_DIGITAL,
    EVERYDAY_DIGITAL_INCREASE,
    WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL,
    WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL_INCREASE,
    FRI_TO_MON_PAPERS_AND_EVERYDAY_DIGITAL,
    FIFTY_OFF_EVERYDAY_DIGITAL,
    FIFTY_OFF_WE_PAPERS_AND_EVERYDAY_DIGITAL,
}

// Check if the passed package is a subscription package
export const isSubscriptionPackage = (obj: any): boolean => {
    return (
        typeof obj !== 'undefined' &&
        Object.entries(breachPackages).filter((entry) => entry[1].includes(obj))
            .length > 0
    )
}

const base50percentDiscountPackage: SubscriptionPackageOptions[] = [
    {
        type: 'single-subscription',
        packageTheme: 'red',
        packagePath: 'subscribe/new',
        heading: 'Everyday Digital',
        price: '50c per day',
        originalPrice: '$1 per day',
        priceQualifier: 'for 8 weeks*',
        packageType: 'digital',
        ribbonTitle: '50% off',
        cancellationMessage: 'Cancel anytime. Min cost $14.',
        rateCode: 'WST_DIGI_$3.50X8W',
        weeklyPrice: EVERYDAY_DIGITAL,
        promoPrice: FIFTY_OFF_EVERYDAY_DIGITAL,
        discount: EVERYDAY_DIGITAL - FIFTY_OFF_EVERYDAY_DIGITAL,
        offerCode: BASE_50_DEAL_OFFERCODE,
    },
    {
        type: 'single-subscription',
        heading: 'Weekend Papers + Everyday Digital',
        price: '$9 per week',
        packagePath: 'subscribenow/sat-sun+digital',
        packageType: 'digitalprint',
        cancellationMessage: 'Cancel anytime. Min cost $36.',
        weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL,
        rateCode: WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE,
    },
]

export const breachPackages: Record<
    BreachWallContentType,
    SubscriptionPackageOptions[]
> = {
    default: [
        {
            type: 'single-subscription',
            packagePath: 'subscribe/new',
            heading: 'Everyday Digital',
            price: '$1 per day',
            packageType: 'digital',
            cancellationMessage: 'Cancel anytime. Min cost $28.',
            googleSKU: 'everyday_digital_4weeks',
            weeklyPrice: EVERYDAY_DIGITAL,
            rateCode: WEEKLY_DIGITAL_RATE_CODE,
        },
        {
            type: 'single-subscription',
            heading: 'Weekend Papers + Everyday Digital',
            price: '$9 per week',
            packagePath: 'subscribenow/sat-sun+digital',
            packageType: 'digitalprint',
            cancellationMessage: 'Cancel anytime. Min cost $36.',
            weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL,
            rateCode: WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE,
        },
    ],
    'default-breachwall-2024': [
        {
            type: 'single-subscription',
            packagePath: 'subscribe/new',
            heading: 'Unlock Digital for',
            price: '$8 per week',
            packageType: 'digital',
            cancellationMessage: 'Cancel anytime. Min cost $32.',
            googleSKU: 'everyday_digital_4weeks_8',
            weeklyPrice: EVERYDAY_DIGITAL_INCREASE,
            rateCode: WEEKLY_DIGITAL_RATE_CODE_INCREASE,
        },
        {
            type: 'single-subscription',
            heading: 'Weekend Papers + Everyday Digital',
            price: '$10 per week',
            packagePath: 'subscribenow/sat-sun+digital',
            packageType: 'digitalprint',
            cancellationMessage: 'Cancel anytime. Min cost $40.',
            weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL_INCREASE,
            rateCode: WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE_INCREASE,
        },
    ],
    Puzzles: [
        {
            type: 'single-subscription',
            packagePath: 'subscribe/new',
            heading: 'Everyday Digital',
            price: '$1 per day',
            packageType: 'digital',
            cancellationMessage: 'Cancel anytime. Min cost $28.',
            googleSKU: 'everyday_digital_4weeks_8',
            weeklyPrice: EVERYDAY_DIGITAL,
            rateCode: WEEKLY_DIGITAL_RATE_CODE,
        },
    ],
    'Puzzles-increase': [
        {
            type: 'single-subscription',
            packagePath: 'subscribe/new',
            heading: 'Everyday Digital',
            price: '$8 per week',
            packageType: 'digital',
            cancellationMessage: 'Cancel anytime. Min cost $32.',
            googleSKU: 'everyday_digital_4weeks_8',
            weeklyPrice: EVERYDAY_DIGITAL_INCREASE,
            rateCode: WEEKLY_DIGITAL_RATE_CODE_INCREASE,
        },
    ],
    'default-price-increase': [
        {
            type: 'single-subscription',
            packagePath: 'subscribe/new',
            heading: 'Everyday Digital',
            price: '$8 per week',
            packageType: 'digital',
            cancellationMessage: 'Cancel anytime. Min cost $32.',
            googleSKU: 'everyday_digital_4weeks_8',
            weeklyPrice: EVERYDAY_DIGITAL_INCREASE,
            rateCode: WEEKLY_DIGITAL_RATE_CODE_INCREASE,
        },
        {
            type: 'single-subscription',
            heading: 'Weekend Papers + Everyday Digital',
            price: '$10 per week',
            packagePath: 'subscribenow/sat-sun+digital',
            packageType: 'digitalprint',
            cancellationMessage: 'Cancel anytime. Min cost $40.',
            weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL_INCREASE,
            rateCode: WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE_INCREASE,
        },
    ],
    'default-annual-package': [
        {
            type: 'single-subscription',
            packagePath: 'subscribe/new',
            heading: 'Subscribe',
            price: '$8 per week',
            priceQualifier: 'Billed every four weeks.',
            packageType: 'digital',
            packageTheme: 'optimise-blue',
            cancellationMessage: 'Cancel anytime. Min cost $32.',
            googleSKU: 'everyday_digital_4weeks_8',
            weeklyPrice: EVERYDAY_DIGITAL_INCREASE,
            rateCode: WEEKLY_DIGITAL_RATE_CODE_INCREASE,
            buttonStyle: 'solid-blue',
            benefitOverride: [
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                '19 WA regional papers',
                'Daily puzzles',
            ],
        },
        {
            type: 'single-subscription',
            heading: 'Subscribe',
            price: '$6 per week',
            priceQualifier: 'Billed annually.',
            ribbonTitle: 'SAVE 25%',
            ribbonOptions: 'bluePill',
            packagePath: 'subscribenow/annual-package',
            packageType: 'digital',
            packageTheme: 'optimise-blue',
            cancellationMessage: 'Cancel anytime. Min cost $312.',
            googleSKU: 'everyday_digital_52weeks_6',
            weeklyPrice: 6,
            rateCode: EVERYDAY_DIGITAL_52_WEEKS_RATE_CODE,
            buttonStyle: 'solid-blue',
            benefitOverride: [
                'Pay upfront and save',
                'Unlimited access to all articles',
                'Digital version of Today’s Paper',
                'Daily puzzles',
                '19 WA regional titles',
            ],
        },
    ],
    'puzzles-swg-30-off': [
        {
            type: 'single-subscription',
            packagePath: 'subscribe/new',
            heading: 'Everyday Digital',
            price: '70c per day',
            ribbonTitle: '30% OFF',
            packageType: 'digital',
            cancellationMessage: 'Cancel anytime. Min cost $28.',
            offerCode: 'PUZ_2024',
            googleSKU: 'everyday_digital_puzzles_offer',
            weeklyPrice: THIRTY_OFF_EVERYDAY_DIGITAL,
            rateCode: THIRTY_OFF_EVERYDAY_DIGITAL_8_WEEKS_RATE_CODE,
        },
    ],
    ePaper: [
        {
            type: 'single-subscription',
            packagePath: 'subscribe/new',
            heading: 'Everyday Digital',
            price: '$1 per day',
            packageType: 'digital',
            cancellationMessage: 'Cancel anytime. Min cost $28.',
            googleSKU: 'everyday_digital_4weeks',
            weeklyPrice: EVERYDAY_DIGITAL,
            rateCode: WEEKLY_DIGITAL_RATE_CODE,
        },
        {
            type: 'single-subscription',
            heading: 'Weekend Papers + Everyday Digital',
            price: '$9 per week',
            packagePath: 'subscribenow/sat-sun+digital',
            packageType: 'digitalprint',
            cancellationMessage: 'Cancel anytime. Min cost $36.',
            weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL,
            rateCode: WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE,
        },
    ],
    'ePaper-price-increase': [
        {
            type: 'single-subscription',
            packagePath: 'subscribe/new',
            heading: 'Everyday Digital',
            price: '$8 per week',
            packageType: 'digital',
            cancellationMessage: 'Cancel anytime. Min cost $32.',
            googleSKU: 'everyday_digital_4weeks_8',
            weeklyPrice: EVERYDAY_DIGITAL_INCREASE,
            rateCode: WEEKLY_DIGITAL_RATE_CODE_INCREASE,
        },
        {
            type: 'single-subscription',
            heading: 'Weekend Papers + Everyday Digital',
            price: '$10 per week',
            packagePath: 'subscribenow/sat-sun+digital',
            packageType: 'digitalprint',
            cancellationMessage: 'Cancel anytime. Min cost $40.',
            weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL_INCREASE,
            rateCode: WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE_INCREASE,
        },
    ],
    'digital-only': [
        {
            type: 'single-subscription',
            packagePath: 'subscribe/new',
            heading: 'Everyday Digitalbbb',
            price: '$1 per day',
            packageType: 'digital',
            cancellationMessage: 'Cancel anytime. Min cost $28.',
            googleSKU: 'everyday_digital_4weeks',
            weeklyPrice: EVERYDAY_DIGITAL,
            rateCode: WEEKLY_DIGITAL_RATE_CODE,
        },
    ],
    'top-50-schools': [
        {
            type: 'single-subscription',
            packageTheme: 'yellow',
            packagePath: 'offercheck/thewest?redirect=true&offerCode=SCHOOL30',
            heading: 'Everyday Digital',
            price: 'Now $4.90 per week',
            originalPrice: 'Was $7 per week',
            priceQualifier: 'for the first 8 weeks*',
            packageType: 'digital',
            ribbonTitle: '30% off*',
            rateCode: THIRTY_OFF_EVERYDAY_DIGITAL_8_WEEKS_RATE_CODE,
            cancellationMessage: 'Cancel anytime. 4 week minimum.',
            weeklyPrice: EVERYDAY_DIGITAL,
            promoPrice: THIRTY_OFF_EVERYDAY_DIGITAL,
            discount: EVERYDAY_DIGITAL - THIRTY_OFF_EVERYDAY_DIGITAL,
            offerCode: 'SCHOOL30',
        },
        {
            type: 'single-subscription',
            heading: 'Weekend Papers + Everyday Digital',
            price: '$9 per week',
            packagePath: 'subscribenow/sat-sun+digital',
            packageType: 'digitalprint',
            cancellationMessage: 'Cancel anytime. 4 week minimum.',
            weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL,
            rateCode: WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE,
        },
    ],
    'vanishing-cousins': [
        {
            type: 'single-subscription',
            packageTheme: 'vanishing-cousins',
            packagePath: 'offercheck/thewest?redirect=true&offerCode=VC23',
            heading: 'Everyday Digital',
            price: '$4.20 per week',
            originalPrice: '$7 per week',
            priceQualifier: 'for the first 8 weeks',
            packageType: 'digital',
            ribbonTitle: 'On Sale',
            ribbonOptions: 'cornerDesignTag',
            offerCode: 'VC23',
            googleSKU: 'everyday_digital_40_percent',
            cancellationMessage: 'Cancel anytime. Min cost $33.60',
            weeklyPrice: EVERYDAY_DIGITAL,
            promoPrice: 4.2,
            discount: 2.8,
            rateCode: 'WST_DIGI_$4.20X8W_DD',
        },
        {
            type: 'single-subscription',
            heading: 'Weekend Papers + Everyday Digital',
            price: '$9 per week',
            packagePath: 'subscribenow/sat-sun+digital',
            packageType: 'digitalprint',
            cancellationMessage: 'Cancel anytime. Min cost $36',
            weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL,
            discount: 0,
            rateCode: WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE,
            packageTheme: 'vanishing-cousins',
        },
    ],
    '50-off-afl-breach-screen': [
        {
            type: 'single-subscription',
            packagePath: 'offercheck/thewest?redirect=true&offerCode=25FOOTY1',
            heading: 'Everyday Digital',
            price: '$4 per week',
            originalPrice: '$8 per week',
            priceQualifier: '*for 8 weeks',
            packageType: 'digital',
            packageTheme: 'optimise-blue',
            buttonStyle: 'solid-red',
            ribbonTitle: 'On sale',
            ribbonOptions: 'cornerDesignTag',
            rateCode: 'WST_DIGI_4X8_1',
            weeklyPrice: EVERYDAY_DIGITAL,
            promoPrice: FIFTY_OFF_EVERYDAY_DIGITAL,
            discount: EVERYDAY_DIGITAL - FIFTY_OFF_EVERYDAY_DIGITAL,
            offerCode: '25FOOTY1',
            googleSKU: 'everyday_digital_footy_pack',
            cancellationMessage: `Cancel anytime. Min cost $32.`,
            benefitOverride: [
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                '19 WA regional papers',
                'Daily puzzles',
            ],
        },
        {
            type: 'single-subscription',
            heading: 'Everyday Digital + Weekend Papers',
            price: '$5 per week',
            originalPrice: '$10 per week',
            priceQualifier: '*for 8 weeks',
            benefitOverride: [
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                '19 WA regional papers',
                'Daily puzzles',
                'Weekend papers delivered',
            ],
            packagePath: 'offercheck/thewest?redirect=true&offerCode=25FOOTY2',
            packageType: 'digitalprint',
            packageTheme: 'optimise-blue',
            buttonStyle: 'solid-red',
            ribbonTitle: 'On sale',
            ribbonOptions: 'cornerDesignTag',
            cancellationMessage: `Cancel anytime. Min cost $40.`,
            rateCode: 'WST_PrSSDIG_5x8_1',
            weeklyPrice: FRI_TO_MON_PAPERS_AND_EVERYDAY_DIGITAL,
            promoPrice: FIFTY_OFF_FRI_TO_MON_PAPERS_AND_EVERYDAY_DIGITAL,
            discount:
                FRI_TO_MON_PAPERS_AND_EVERYDAY_DIGITAL -
                FIFTY_OFF_FRI_TO_MON_PAPERS_AND_EVERYDAY_DIGITAL,
            offerCode: '25FOOTY2',
        },
    ],
    'subs-campaign-eofy-weekend-digital': [
        {
            type: 'single-subscription',
            packagePath: 'offercheck/thewest?redirect=true&offerCode=25EOFY1',
            heading: 'Everyday Digital',
            price: '$4/week',
            originalPrice: '$8 per week',
            priceQualifier: '*for 8 weeks',
            packageType: 'digital',
            packageTheme: 'optimise-blue',
            ribbonTitle: 'On sale',
            ribbonOptions: 'cornerDesignTag',
            offerCode: '25EOFY1',
            googleSKU: 'everyday_digital_eofy',
            cancellationMessage: `Cancel anytime. Min cost $32`,
            weeklyPrice: EVERYDAY_DIGITAL,
            promoPrice: FIFTY_OFF_EVERYDAY_DIGITAL,
            discount: EVERYDAY_DIGITAL - FIFTY_OFF_EVERYDAY_DIGITAL,
            rateCode: 'WST_DIGI_4X8_1',
            buttonStyle: 'solid-blue',
            benefitOverride: [
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                '19 WA regional papers',
                'Daily puzzles',
            ],
        },
        {
            type: 'single-subscription',
            packagePath: 'offercheck/thewest?redirect=true&offerCode=25EOFY2',
            heading: 'Everyday Digital & Weekend Papers',
            price: '$5/week',
            originalPrice: '$10 per week',
            priceQualifier: '*for 8 weeks',
            packageType: 'digitalprint',
            packageTheme: 'optimise-blue',
            ribbonTitle: 'On sale',
            ribbonOptions: 'cornerDesignTag',
            offerCode: '25EOFY2',
            cancellationMessage: `Cancel anytime. Min cost $40`,
            rateCode: 'WST_PrSSDIG_5x8_1',
            weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL,
            promoPrice: FIFTY_OFF_WE_PAPERS_AND_EVERYDAY_DIGITAL,
            discount:
                WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL -
                FIFTY_OFF_WE_PAPERS_AND_EVERYDAY_DIGITAL,
            buttonStyle: 'solid-blue',
            benefitOverride: [
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                '19 WA regional papers',
                'Daily puzzles',
                'Weekend papers delivered',
            ],
        },
    ],
    'black-friday': [
        {
            type: 'single-subscription',
            packagePath: 'offercheck/thewest?redirect=true&offerCode=BLKFRI10',
            heading: 'Everyday Digital',
            price: '$4/week',
            originalPrice: '$8 per week',
            billingCycle: 'Billed every week',
            priceQualifier: '*for 8 weeks',
            packageType: 'digital',
            ribbonTitle: 'On sale',
            ribbonOptions: 'cornerDesignTag',
            buttonStyle: 'solid-blue',
            offerCode: 'BLKFRI10',
            googleSKU: 'everyday_digital_50_off',
            cancellationMessage: 'Cancel anytime. Min cost $16',
            weeklyPrice: EVERYDAY_DIGITAL,
            promoPrice: FIFTY_OFF_EVERYDAY_DIGITAL,
            discount: EVERYDAY_DIGITAL - FIFTY_OFF_EVERYDAY_DIGITAL,
            rateCode: 'WST_DIG_weekly4X8_1',
            benefitOverride: [
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                'Daily puzzles',
                '19 WA regional titles',
            ],
        },
        {
            type: 'single-subscription',
            packagePath: 'offercheck/thewest?redirect=true&offerCode=BLKFRI2',
            heading: 'Everyday Digital + Weekend Papers',
            price: '$5/week',
            originalPrice: '$10 per week',
            billingCycle: 'Billed every four weeks',
            priceQualifier: '*for 8 weeks',
            packageType: 'digitalprint',
            ribbonTitle: 'On sale',
            ribbonOptions: 'cornerDesignTag',
            buttonStyle: 'solid-blue',
            offerCode: 'BLKFRI2',
            cancellationMessage: 'Cancel anytime. Min cost $20',
            weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL,
            promoPrice: FIFTY_OFF_WE_PAPERS_AND_EVERYDAY_DIGITAL,
            discount:
                WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL -
                FIFTY_OFF_WE_PAPERS_AND_EVERYDAY_DIGITAL,
            rateCode: 'WST_PrSSDIG_5x8_1',
        },
    ],
    '50-off-breach-discount': base50percentDiscountPackage,
    'business-pack': [
        {
            type: 'single-subscription',
            packagePath: 'offercheck/thewest?redirect=true&offerCode=BUSN2',
            heading: 'Everyday Digital',
            originalPrice: '$1 per day',
            price: '$0.70  per day',
            packageType: 'digital',
            cancellationMessage: 'Cancel anytime. Min cost $28.',
            ribbonTitle: '30% OFF*',
            rateCode: THIRTY_OFF_EVERYDAY_DIGITAL_8_WEEKS_RATE_CODE,
            priceQualifier: 'for the first 8 weeks*',
            weeklyPrice: EVERYDAY_DIGITAL,
            promoPrice: THIRTY_OFF_EVERYDAY_DIGITAL,
            discount: EVERYDAY_DIGITAL - THIRTY_OFF_EVERYDAY_DIGITAL,
            offerCode: 'BUSN2',
        },
        {
            type: 'single-subscription',
            heading: 'Weekend Papers + Everyday Digital',
            price: '$9 per week',
            packagePath: 'subscribenow/sat-sun+digital',
            packageType: 'digitalprint',
            cancellationMessage: 'Cancel anytime. Min cost $36.',
            weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL,
            rateCode: WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE,
        },
    ],
    'sport-pack': [
        {
            type: 'single-subscription',
            packagePath: 'offercheck/thewest?redirect=true&offerCode=SP3022',
            heading: 'Everyday Digital',
            originalPrice: '$1 per day',
            price: '$0.70  per day',
            packageType: 'digital',
            cancellationMessage: 'Cancel anytime. Min cost $28.',
            ribbonTitle: '30% OFF*',
            priceQualifier: 'for the first 8 weeks*',
            rateCode: THIRTY_OFF_EVERYDAY_DIGITAL_8_WEEKS_RATE_CODE,
            weeklyPrice: EVERYDAY_DIGITAL,
            promoPrice: THIRTY_OFF_EVERYDAY_DIGITAL,
            discount: EVERYDAY_DIGITAL - THIRTY_OFF_EVERYDAY_DIGITAL,
            offerCode: 'SP3022',
        },
        {
            type: 'single-subscription',
            heading: 'Weekend Papers + Everyday Digital',
            price: '$9 per week',
            packagePath: 'subscribenow/sat-sun+digital',
            packageType: 'digitalprint',
            cancellationMessage: 'Cancel anytime. Min cost $36.',
            weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL,
            rateCode: WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE,
        },
    ],
    sport: [
        {
            type: 'single-subscription',
            heading: 'Digital + Print',
            originalPrice: '$13 per week',
            price: '$7.50 per week',
            priceQualifier: 'for the first 8 weeks*',
            weeklyPrice: 7.5,
            discount: 5.5,
            rateCode: SPORT_BREACH_DIGITAL_PRINT_RATE_CODE,
            packagePath: '',
            offerCode: 'FOOTYPAK',
        },
        {
            type: 'single-subscription',
            packagePath: 'subscribe/new',
            heading: 'Digital Only',
            price: '$3.50 per week',
            priceQualifier: 'for the first 8 weeks*',
            packageType: 'digital',
            weeklyPrice: FIFTY_OFF_EVERYDAY_DIGITAL,
            discount: EVERYDAY_DIGITAL - FIFTY_OFF_EVERYDAY_DIGITAL,
            rateCode: FIFTY_OFF_EVERYDAY_DIGITAL_8_WEEKS_RATE_CODE,
        },
    ],
    'digital-radio-and-papers': [
        {
            type: 'radio-list-subscriptions',
            heading: 'Everyday Digital',
            prices: [
                {
                    price: '$6 per week',
                    priceQualifier: 'Billed annually',
                    packagePath: 'subscribenow/annual-package',
                    rateCode: EVERYDAY_DIGITAL_52_WEEKS_RATE_CODE,
                    weeklyPrice: 6,
                    googleSKU: 'everyday_digital_52weeks_6',
                    ribbonTitle: 'SAVE 25%',
                    ribbonOptions: 'bluePill',
                    cancellationMessage: 'Cancel anytime. Min cost $312.',
                },
                {
                    price: '$8 per week',
                    priceQualifier: 'Billed every four weeks',
                    packagePath: 'subscribe/new',
                    rateCode: WEEKLY_DIGITAL_RATE_CODE_INCREASE,
                    weeklyPrice: EVERYDAY_DIGITAL_INCREASE,
                    googleSKU: 'everyday_digital_4weeks_8',
                    cancellationMessage: 'Cancel anytime. Min cost $32.',
                },
            ],
            packageType: 'digital',
            packageTheme: 'optimise-blue',
            buttonStyle: 'solid-blue',
            benefitOverride: [
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                'Daily puzzles',
                '19 WA regional titles',
            ],
        },
        {
            type: 'radio-list-subscriptions',
            heading: 'Everyday Digital + Weekend Papers',
            prices: [
                {
                    price: '$10 per week',
                    priceQualifier: 'Billed every four weeks',
                    packagePath: 'subscribenow/sat-sun+digital',
                    rateCode: WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE_INCREASE,
                    weeklyPrice: WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL_INCREASE,
                    cancellationMessage: 'Cancel anytime. Min cost $40.',
                },
            ],
            packageType: 'digitalprint',
            packageTheme: 'optimise-blue',
            buttonStyle: 'solid-blue',
            benefitOverride: [
                'Weekend papers delivered',
                'Unlimited access to thewest.com.au',
                'Digital version of Today’s Paper',
                'Daily puzzles',
                '19 WA regional titles',
            ],
        },
    ],
}

export function packageOfferDetails(
    type: BreachWallContentType,
): SubscriptionPackages {
    const packages: SubscriptionPackages = []
    switch (type) {
        case '50-off-breach-discount':
            breachPackages['50-off-breach-discount'].forEach((pack) => {
                packages.push(pack)
            })
            break

        case '50-off-afl-breach-screen':
            breachPackages['50-off-afl-breach-screen'].forEach((pack) => {
                packages.push(pack)
            })
            break

        default:
            breachPackages[type].forEach((pack) => {
                packages.push(pack)
            })
            break
    }

    return packages
}

/**
 * Retrieves subscription packages for a given breach wall content type.
 * Unlike `packageOfferDetails`, this function specifically handles RRME breach packages.
 * Now supports dynamic loading from the subscription offer API.
 *
 * @param {BreachWallContentType} type - The type of breach wall content to retrieve packages for.
 * @returns {SubscriptionPackages} An array of subscription packages corresponding to the given type.
 *
 * Note: The switch statement is currently limited to a default case. As more offers are added
 * in Google Publisher Center, this function should be updated to handle specific cases similar
 * to `packageOfferDetails`.
 */
export function rrmePackageOfferDetails(
    type: BreachWallContentType,
): SubscriptionPackages {
    const packages: SubscriptionPackages = []
    const currentBreachPackages = getRrmeOfferPackages('breach')

    switch (type) {
        default:
            currentBreachPackages[type]?.forEach((pack) => {
                packages.push(pack)
            })
            break
    }

    return packages
}

export function getWeeklyPrice(rateCode: string): number {
    switch (rateCode) {
        case WEEKLY_DIGITAL_RATE_CODE:
            return EVERYDAY_DIGITAL
        case WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE:
            return WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL
        case FIFTY_OFF_EVERYDAY_DIGITAL_12_WEEKS_RATE_CODE:
            return FIFTY_OFF_EVERYDAY_DIGITAL
        case FIFTY_OFF_FRI_MON_PAPER_AND_DIGITAL_12_WEEKS_RATE_CODE:
            return FIFTY_OFF_FRI_TO_MON_PAPERS_AND_EVERYDAY_DIGITAL
        case FIFTY_OFF_EVERYDAY_DIGITAL_8_WEEKS_RATE_CODE:
            return FIFTY_OFF_EVERYDAY_DIGITAL
        default:
            return 0
    }
}

export function useUpdateBreachWallContext({
    publication,
    breachCreativeName,
    breachDeal,
    leadDepth,
    offerCode,
    packagePath,
    requiredAccessLevel,
}: BreachContext) {
    const breachScreenContext = useContext(BreachScreenContext)

    const authentication = useSelector<AppState, AuthenticationState>(
        (state) => state.authentication,
    )

    const { entitlements, isLoggedIn } = authentication

    // a returning user is a user who has registered, logged in, and has not completed a purchase
    const returningUser = isLoggedIn && !entitlements?.includes(THEWEST_ALL)

    useEffect(() => {
        breachScreenContext.setContext({
            publication,
            returningUser,
            breachCreativeName,
            breachDeal,
            leadDepth,
            offerCode,
            packagePath,
            requiredAccessLevel,
        })
        return () => {
            breachScreenContext.clearContext()
        }

        // We can ignore the breachScreenContext dependency because the setContext and clearContext functions aren't going to change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        returningUser,
        publication,
        breachCreativeName,
        breachDeal,
        leadDepth,
        offerCode,
        packagePath,
        requiredAccessLevel,
    ])
}
